'use client';
import '@/components/landingComponents/Carousel.css';
import SearchFormLandingPageLazyLoading from '@/components/landingComponents/SearchFormLandingPageLazyLoading';
import ScreenerNavbar from '@/components/screenerComponents/ScreenerNavbar';
import { getCookie } from '@/services/helperFunctions';
import { faArrowRight, faChartLine, faListCheck, faStopwatch, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Card, Col, Container, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as bondsAction from '../redux/actions/bonds';
import * as commonAction from '../redux/actions/common';
import { EXIST_LOCAL_STORAGE } from '../services/constants';
import './LandingPage.css';
import { makeNavigationSiteAnalytics } from '@/services/simpleApis';

const Carousel = dynamic(() => import('@/components/landingComponents/Carousel'), {
    ssr: true,
    loading: () => (
        <div className="unique-carousel">
            <Image
                src="/img/Datareport.webp"
                alt="Loadingimage"
                width={600}
                height={400}
                priority
                fetchPriority="high"
                className={`unique-carousel-image unique-active`}
                unoptimized
            />
        </div>
    ),
});

const SearchFormLandingPage = dynamic(() => import('@/components/landingComponents/SearchFormLandingPage'), {
    ssr: true,
    loading: () => <SearchFormLandingPageLazyLoading />,
});

const PartnersFooterSection = dynamic(() => import('@/components/partnersPageComponents/PartnersFooterSection'), {
    ssr: true,
    loading: () => <p>Loading...</p>,
});

// const userSchema = yup.object().shape({
//     name: yup.string().required('Name  is required'),
//     email: yup.string().email().required('Email is required'),
//     message: yup.string().required('Message  is required'),
// });

const servicedata = [
    {
        // icon: <MenuButtonWideFill color='#294672' size={50} />,
        title: 'Bonds Search',
        img: '/img/bondscreener.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
    {
        // icon: <CreditCard2Front color='#294672' size={50} />,
        title: 'Bonds Details',
        img: '/img/bonddetailmock.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
    {
        // icon: <ColumnsGap color='#294672' size={50} />,
        title: 'Dashboard',
        img: '/img/dashboardmock.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
    {
        // icon: <Collection color='#294672' size={50} />,
        title: 'Trade Broadcast',
        img: '/img/dashboardmock.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
    {
        // icon: <ChatRightText color='#294672' size={50} />,
        title: 'Discussion Panel',
        img: '/img/discussionmock.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
    {
        // icon: <FileEarmarkPost color='#294672' size={50} />,
        title: 'Portfolio Panel',
        img: '/img/portfoliomock.webp',
        description:
            ' Stop wasting time money designing and more other option ,Stop wasting time money designing and more other option Stop wasting time money designing and more other option Stop wasting time money designing and more other option.',
    },
];

const LandingPage: React.FC = () => {
    const [fadeIn, setFadeIn] = useState(false);
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        const timeoutId = setTimeout(() => {
            setFadeIn(true);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, []);

    const [showOurServicesImage, setShowOurServicesImage] = useState({
        showOurServicesImage: false,
        imageTitle: '',
        imageFile: '',
    });

    const timerRef = useRef<null | NodeJS.Timeout>(null);

    const toggleShowOurServicesImage = useCallback((imgTitle = '', imgeName = '', showModal = false) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        const newTimer = setTimeout(() => {
            setShowOurServicesImage({
                showOurServicesImage: showModal,
                imageTitle: imgTitle,
                imageFile: imgeName,
            });
        }, 500);
        timerRef.current = newTimer;
    }, []);

    const userFullName = useMemo(() => getCookie(EXIST_LOCAL_STORAGE.USERNAME), []);

    return (
        <div>
            <ScreenerNavbar />
            <div className={`landing-page-component`}>
                <section className=" mt-sm-0" style={{ zIndex: 0, position: 'relative' }}>
                    <div className="pt-3 bg-landingpage">
                        <Container fluid className={`px-4 `}>
                            <Row>
                                <Col lg={6} sm={12}>
                                    <div className="d-flex justify-content-center flex-column bg-height-left">
                                        {userFullName && (
                                            <p className="font-weight-800 mt-3 fs-4 text-white">Welcome back, {userFullName}</p>
                                        )}
                                        <p className="font-weight-900 fs-1 pb-2">SQX BONDS</p>

                                        <div className="d-flex gap-2 text-white">
                                            <h1 className="fs-6 fw-normal pb-0  lh-1 mb-0">
                                                {' '}
                                                <span className="fs-6 fw-normal pb-0 mb-1 lh-1">Welcome to</span> SQX Bonds, your free
                                                fixed-income database!
                                            </h1>{' '}
                                        </div>
                                        <p className="mt-1">
                                            We offer free reference data and price updates on over 170,000 corporate bonds and structured
                                            notes.
                                        </p>
                                        {!userFullName && (
                                            <Link href="/registerpage" className="col-10 col-sm-8 col-md-8 mt-lg-4 mt-1">
                                                <button className="banner-button-landing">
                                                    <FontAwesomeIcon icon={faUserPlus} /> REGISTER FOR A FREE ACCOUNT!
                                                </button>
                                            </Link>
                                        )}

                                        <div className="d-flex flex-column flex-sm-row gap-sm-2 col-md-8 col-lg-12 transition-smooth">
                                            <a href="#feature-bond" className="mt-lg-2 col-10 col-sm-6 mt-lg-2 mt-1">
                                                <button className="banner-button-landing d-flex align-items-center justify-content-between">
                                                    See more services&nbsp;
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                </button>
                                            </a>

                                            <Link
                                                href="/screener"
                                                onClick={() => void makeNavigationSiteAnalytics('Go to Main site', '/screener')}
                                                className="banner-button-landing mt-lg-2 mt-1 d-flex align-items-center justify-content-between"
                                                style={{ maxWidth: '200px' }}
                                            >
                                                Go to the Main Site&nbsp;
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} sm={12} className="d-none d-lg-block">
                                    <div className="d-flex justify-content-center align-items-center position-relative bg-height-right">
                                        <div className={`user-box-landing ${!fadeIn ? 'fadeInUp-userbox-animation' : ''}`}>
                                            <div className="d-flex gap-4 gap-lg-2 justify-content-between">
                                                <div>
                                                    <p className="mb-0 fw-bold">80,000+</p> <p className="mb-0 fw-bold">bonds</p>
                                                </div>
                                                <div className="cirlce-icon-box">
                                                    {/* <WindowPlus size={20} color='white' /> */}
                                                    <FontAwesomeIcon icon={faListCheck} size="lg" color="white" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`notification-box-landing ${!fadeIn ? '' : ''}`}>
                                            <div className="d-flex gap-2 justify-content-between">
                                                <div>
                                                    <p className="mb-0 fw-bold">A free account </p>{' '}
                                                    <p className="mb-0 fw-bold">in seconds</p>
                                                </div>
                                                <div className="cirlce-icon-box">
                                                    {/* <StopwatchFill size={20} color='white' /> */}
                                                    <FontAwesomeIcon icon={faStopwatch} size="lg" color="white" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`featured-box-landing ${!fadeIn ? 'fadeInUp-featured-animation' : ''}`}>
                                            <div className="d-flex gap-2 justify-content-between">
                                                <div>
                                                    <p className="mb-0 fw-bold">Details on new</p>{' '}
                                                    <p className="mb-0 fw-bold">and trending bonds</p>
                                                </div>
                                                <div className="cirlce-icon-box">
                                                    <FontAwesomeIcon icon={faChartLine} size="lg" color="white" />
                                                </div>
                                            </div>
                                        </div>
                                        <Carousel />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>

                <section className="pb-4" id="featured-bonds-landing-page">
                    <div className="px-4">
                        <Container></Container>
                        <Row>
                            <Col lg={12} sm={12}>
                                <div>
                                    <div className="d-flex justify-content-center gap-4 py-2 align-items-center">
                                        <h2 className="text-center title-text-color-landing">SEARCH BONDS</h2>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="container-fluid bg-body-tertiary px-5 py-2">
                        <SearchFormLandingPage />
                    </div>
                </section>
                <section></section>
                <section className="py-3">
                    <div className="container-fluid px-3">
                        <div className="row px-3">
                            <h2 className="text-center title-text-color-landing d-flex align-items-center justify-content-center gap-2 d-flex flex-column flex-lg-row">
                                <span className="d-flex align-items-center gap-4">
                                    ACCESS <Image loading="eager" src={'/img/SQXBondsColorLogo.png'} alt="logo" width="150" height={42} unoptimized />
                                </span>
                                <span className="text-lg-nowrap">MASSIVE UNIVERSE OF DATA — EVEN WITHOUT AN ACCOUNT</span>
                            </h2>
                            <div className="col-lg-6 col-sm-12">
                                <div className="bond-screener-image-container">
                                    <Image
                                        alt="screener-image"
                                        src={'/img/landing-mock.webp'}
                                        className="img-fluid"
                                        width={600}
                                        height={400}
                                        unoptimized
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <div className="">
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3  animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">DISCOVER BONDS</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                SQX's Bond Screener gives you access to over 80,000 bonds
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">DAILY PRICE UPDATES</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                SQX provides evaluated prices for its entire universe of bonds
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">HISTORICAL PRICE DATA</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">Track the price of individual bonds over time</Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">BASIC REFERENCE DATA</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">Get identifying bond information</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-3">
                    <div className="container-fluid px-3">
                        <div className="row px-3">
                            <h2 className="text-center title-text-color-landing d-flex align-items-center justify-content-center gap-2 d-flex flex-column flex-md-row">
                                <span>FOR THE FULL RANGE OF</span>
                                <span>
                                    <Image loading="lazy" alt="sqx-logo" src={'/img/SQXBondsColorLogo.png'} height={42} width={150} unoptimized />{' '}
                                    FEATURES,
                                </span>
                                <span>SIGN UP FOR A FREE ACCOUNT!</span>
                            </h2>
                            <div className="col-lg-6 col-sm-12">
                                <div className="">
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">PREMIUM DATA</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                {' '}
                                                Access full reference information and analytics for sophisticated trading decisions
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">UNLIMITED PORTFOLIOS</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                Test regional and global trading strategies with fantasy portfolios that enable you to track
                                                the P/L of bonds in a variety of currencies
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">TRADING DASHBOARD</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                See daily prices for portfolios, recent issues, and big movers at a glance
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">DISCUSSION BOARD</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                Tap into the wisdom of crowds through an online community with other traders
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card style={{ width: '100%' }} className="border-0 shadow-sm my-3 animation-landing-box-bonds">
                                        <Card.Body>
                                            <Card.Title>
                                                <h3 className="fs-6">TRADE BROADCAST</h3>
                                            </Card.Title>
                                            <Card.Text className="text-secondary">
                                                {' '}
                                                Learn from the trades of other SQX users and share your trades with others
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <div className="bond-screener-image-container mt-4">
                                    <Image
                                        loading="lazy"
                                        alt="bonds"
                                        src={'/img/bonddetailmock.webp'}
                                        className="img-fluid mt-4"
                                        width={1000}
                                        height={600}
                                        unoptimized
                                    />
                                    <div className="text-center">
                                        {!userFullName && (
                                            <Link href="/registerpage" style={{ maxWidth: '250px' }}>
                                                <button
                                                    className="banner-button-landing mt-lg-4 mt-1 text-nowrap shibui-text"
                                                    style={{ maxWidth: '60%' }}
                                                >
                                                    <FontAwesomeIcon icon={faUserPlus} /> REGISTER FOR A FREE ACCOUNT!
                                                </button>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-4" id="feature-bond">
                    <div>
                        <h2 className="text-center title-text-color-landing">OUR SERVICES</h2>
                    </div>
                    <div className="container-fluid px-3 py-5">
                        <div className="row px-3">
                            {servicedata?.map((item: any) => {
                                return (
                                    <div key={item?.title} className="mt-3 col-lg-4 col-sm-12" id="our-services">
                                        <div className="box-service-layout d-flex justify-content-center py-4 px-lg-4 px-2">
                                            <div className="servive-heading-text-color-landing" tabIndex={0}>
                                                <div className="text-center service-icon-landing   mt-3"></div>
                                                <h3 className="text-center">{item?.title}</h3>
                                                <div>
                                                    <Image
                                                        alt={item?.title}
                                                        src={item?.img || './img/Placeolder.png'}
                                                        width={600}
                                                        height={400}
                                                        className="img-fluid cursor-pointer"
                                                        onMouseMoveCapture={() => toggleShowOurServicesImage(item?.title, item?.img, true)}
                                                        onMouseOut={() => timerRef.current && clearTimeout(timerRef.current)}
                                                        unoptimized
                                                    />
                                                </div>
                                                {/* <p className='text-center'>
                                                    {item?.description}
                                                </p> */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

                <PartnersFooterSection />

                <Modal
                    show={showOurServicesImage.showOurServicesImage}
                    onHide={() => {
                        setShowOurServicesImage({ imageTitle: '', imageFile: '', showOurServicesImage: false });
                    }}
                    size="xl"
                    dialogClassName="modal-100w"
                    centered
                    aria-labelledby="example-custom-modal-styling-title-xl"
                >
                    <Modal.Header closeButton className="bg-theme">
                        <Modal.Title id="example-custom-modal-styling-title-lg" className="modal-heading h5 ">
                            <h1 className=""> {showOurServicesImage.imageTitle}</h1>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="user-select-none d-flex justify-content-center">
                            <Image
                                fetchPriority="auto"
                                width={700}
                                height={500}
                                src={showOurServicesImage.imageFile}
                                alt="our-services"
                                className="margin-img-top-cus"
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

const mapStatesToProps = ({
    common: { trendingBondsData = [], isTrendingBondsLoader = true, countryData = [], isCountryLoader = false },
    bonds: { bondsData = {}, noFilterBonds = [], isBoandsLoader = false, clientIp = '0.0.0.0' },
}) => {
    return { bondsData, noFilterBonds, isBoandsLoader, clientIp, trendingBondsData, isTrendingBondsLoader, countryData, isCountryLoader };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...commonAction,
            ...bondsAction,
        },
        dispatch
    );
};

export default connect(mapStatesToProps, mapDispatchToProps)(memo(LandingPage));
